<script lang="ts" setup>
const { md } = useBreakpointTailwind();

const { template } = storeToRefs(useTemplateStore());
</script>

<template>
  <section
    v-if="template.wishes.enabled"
    id="wishes"
    class="p-section relative h-safe-min-screen max-h-full flex justify-center overflow-hidden bg-primary-50 border-none ring-0 outline-0"
  >
    <!-- Mobile Assets -->
    <NuxtImg
      v-if="!md"
      src="/wishes-multiply-flower-mobile.webp"
      alt="Multiply Flower Decoration"
      class="absolute top-0 left-0 w-auto h-[472px] pointer-event-none object-cover smooth-wave-flower-right md:hidden"
      loading="eager"
      decoding="async"
      fetchpriority="high"
      :preload="{
        fetchPriority: 'high',
      }"
    />

    <!-- Desktop Assets -->
    <NuxtImg
      v-if="md"
      src="/wishes-multiply-flower-desktop.webp"
      alt="Multiply Flower Decoration"
      class="hidden absolute top-0 left-0 w-auto h-[891px] object-cover smooth-wave-flower-right md:block"
      loading="eager"
      decoding="async"
      fetchpriority="high"
      :preload="{
        fetchPriority: 'high',
      }"
    />

    <!-- Flower Decoration -->
    <NuxtImg
      src="/date-flower.webp"
      alt="Flower Decoration"
      class="absolute bottom-0 left-0 pointer-events-none w-[120px] h-auto xs:w-[150px] md:w-3xs lg:w-xs"
      loading="eager"
      decoding="async"
      fetchpriority="high"
      :preload="{
        fetchPriority: 'high',
      }"
    />

    <NuxtImg
      src="/wishes-flower-right-desktop.webp"
      alt="Flower Decoration"
      class="absolute bottom-0 right-0 pointer-events-none w-[120px] h-auto xs:w-[150px] md:w-3xs lg:w-xs"
      loading="eager"
      decoding="async"
      fetchpriority="high"
      :preload="{
        fetchPriority: 'high',
      }"
    />

    <NuxtImg
      src="/events-glitter-desktop.webp"
      alt="Glitter Decoration"
      class="absolute w-[107.34px] h-auto object-cover -scale-x-100 right-[6%] md:top-0 md:right-0 md:w-[228.23px]"
      loading="eager"
      decoding="async"
      fetchpriority="high"
      :preload="{
        fetchPriority: 'high',
      }"
    />

    <!-- Content -->
    <PWishesContent />
  </section>
</template>

<style lang="css" scoped>
:deep(.smooth-wave-flower-right) {
  --rot: -0.2deg;
  --x: -8px;
  --y: 12px;
  --breath: 0.012;

  transform-origin: bottom left;
  will-change: translate, rotate, scale, filter;

  translate: 0 0;
  rotate: 0deg;
  scale: 1;

  animation:
    alive-sway 3.5s ease-in-out infinite alternate,
    alive-breath 6.5s ease-in-out infinite;
  filter: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.16));
}
</style>
